var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce container"},[_vm._m(0),_c('div',{staticClass:"intro-text"},[_vm._v("\n    "+_vm._s(_vm.introduce)+"\n  ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-logo"},[_c('img',{attrs:{"src":require("../assets/images/jinsehotLogoIntro.svg")}})])
}]

export { render, staticRenderFns }